export const convertNumber = (number) => {
  if (typeof number !== 'number') {
    return number; // Return as-is if not a number
  }
  
  const numberWithCommas = number.toLocaleString();
  const arr = numberWithCommas.split(",");
  
  switch (arr.length) {
    case 5: // Trillions
      return `${arr[0]}.${arr[1].slice(0, 2)}T`;
    case 4: // Billions
      return `${arr[0]}.${arr[1].slice(0, 2)}B`;
    case 3: // Millions
      return `${arr[0]}.${arr[1].slice(0, 2)}M`;
    case 2: // Thousands
      return `${arr[0]}.${arr[1].slice(0, 2)}K`;
    default: // Hundreds or less
      return number.toLocaleString();
  }
};